import {
  DynamicFormInputType,
  FormInputTypes,
} from '@components/_old/dynamicForm';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  basicCurrency: '',
  secondaryCurrency: '',
};

export const inputs: Record<string, DynamicFormInputType> = {
  basicCurrency: {
    name: 'basicCurrency',
    title: 'Basic Currency',
    type: FormInputTypes.newselect,
    placeholder: 'Basic Currency (Local Currency)',
    value: !isEmpty(initialValues.basicCurrency)
      ? initialValues.basicCurrency
      : [],
    required: true,
    disabled: false,
    hasTooltip: true,
    tooltipText: 'Local Currency',
    injectGlobalLov: {
      type: 'currency',
      value: 'Id',
      display: 'Title',
    },
  },
  secondaryCurrency: {
    name: 'secondaryCurrency',
    title: 'Secondary Currency',
    type: FormInputTypes.newselect,
    placeholder: 'Secondary Currency (Foreign Currency)',
    value: !isEmpty(initialValues.secondaryCurrency)
      ? initialValues.secondaryCurrency
      : [],
    required: true,
    disabled: false,
    hasTooltip: true,
    tooltipText: 'Foreign Currency',
    injectGlobalLov: {
      type: 'currency',
      value: 'Id',
      display: 'Title',
    },
  },
};
